import {
    useAppContext
} from "../context/AppContext";

import slideData from "../data/data";

const DownCaret = ({isActive}) => (
  <svg
    className={`${!isActive ? `` : `js-open`}`}
    viewBox="0 0 31.715 17.357"
    height="13"
    width="27"
  >
    <path
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      d="m2.122 2.122 13.736 13.736L29.595 2.122"
    />
  </svg>
);

const Navigation = () => {
    const {
      activeIdx,
      breakpoint,
      setActiveIdx,
      showResults,
      mobileMenuIsOpen,
      toggleMobileMenu,
      viewportWidth
    } = useAppContext();

    const clickHandler = (index) => {
        setActiveIdx(index) 
        window.scrollTo(0, 0);
    }

    const slidesList = slideData.map((slide, idx) =>
        <li
            key={idx}
            className={`${activeIdx === idx ? `active-page` : ``} ${
                showResults || activeIdx === slideData.length - 1
                ? `disabled`
                : ``
            }`}
            onClick={() =>
                !showResults && (activeIdx + 1 < slideData.length)
                ? clickHandler(idx)
                : ``
            }
        >
            <span dangerouslySetInnerHTML={{ __html: slide.label }} />
        </li>
    );    

    return (
      <aside>
        {((activeIdx !== null) && (viewportWidth < breakpoint)) && (
          <div className="mobile-nav-header" onClick={toggleMobileMenu}>
            <p
              dangerouslySetInnerHTML={{
                __html: slideData[`${activeIdx}`].label,
              }}
            ></p>
            <div className="toggle-menu">
              <DownCaret isActive={mobileMenuIsOpen} />
            </div>
          </div>
        )}
        <nav className={`postiva-nav ${!mobileMenuIsOpen ? `` : `js-open`}`}>
          <ul>{slidesList}</ul>
        </nav>
      </aside>
    );
};

export default Navigation;